/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_State_Select_PlaceholderInputs */

const en_explorer_info_state_select_placeholder = /** @type {(inputs: Explorer_Info_State_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a new state`)
};

const fr_explorer_info_state_select_placeholder = /** @type {(inputs: Explorer_Info_State_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner un nouvel etat`)
};

const de_explorer_info_state_select_placeholder = /** @type {(inputs: Explorer_Info_State_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen neuen Bundesstaat aus`)
};

const it_explorer_info_state_select_placeholder = /** @type {(inputs: Explorer_Info_State_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un nuovo stato`)
};

const ru_explorer_info_state_select_placeholder = /** @type {(inputs: Explorer_Info_State_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите новый штат`)
};

const es_explorer_info_state_select_placeholder = /** @type {(inputs: Explorer_Info_State_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un nuevo estado`)
};

const zh_cn2_explorer_info_state_select_placeholder = /** @type {(inputs: Explorer_Info_State_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个新的州`)
};

const ja_explorer_info_state_select_placeholder = /** @type {(inputs: Explorer_Info_State_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい州を選択`)
};

const hi_explorer_info_state_select_placeholder = /** @type {(inputs: Explorer_Info_State_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक नया राज्य चुनें`)
};

const pt_pt2_explorer_info_state_select_placeholder = /** @type {(inputs: Explorer_Info_State_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um novo estado`)
};

/**
* | output |
* | --- |
* | "Select a new state" |
*
* @param {Explorer_Info_State_Select_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_state_select_placeholder = /** @type {((inputs?: Explorer_Info_State_Select_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_State_Select_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_state_select_placeholder(inputs)
	if (locale === "de") return de_explorer_info_state_select_placeholder(inputs)
	if (locale === "it") return it_explorer_info_state_select_placeholder(inputs)
	if (locale === "ru") return ru_explorer_info_state_select_placeholder(inputs)
	if (locale === "es") return es_explorer_info_state_select_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_state_select_placeholder(inputs)
	if (locale === "ja") return ja_explorer_info_state_select_placeholder(inputs)
	if (locale === "hi") return hi_explorer_info_state_select_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_state_select_placeholder(inputs)
	return en_explorer_info_state_select_placeholder(inputs)
});